import { FailedToGetData, Loading } from '../_commons';
import { houseToHouseServices } from 'src/services';
import { HTHBuildingModal } from 'src/components/_commons/house-to-house';
import { millisecondsFiveMinutes, sseEvents } from '@monorepo/helpers';
import { setAlertResponse, setValuesAndOpenAlertModalReducer } from 'src/store';
import { sse } from '@/app-config';
import { typeBlock, typeConfigDoc, typeFace, typeHTHBuilding, typeHTHFace, typeTerritoryNumber } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { useIdleTimeout } from 'src/custom-hooks';
import { useNavigate, useParams } from 'react-router';

export const HTHBuildingPage = () => {
    const params = useParams();
    //
    const block = params.block as typeBlock;
    const congregation = parseInt(params.congregation || '');
    const face = params.face as typeFace;
    const streetNumber = parseInt(params.streetNumber || '');
    const territoryNumber = params.territoryNumber as typeTerritoryNumber;
    //
    const [congregationConfig, setCongregationConfig] = useState<typeConfigDoc | null>(null);
    const [currentBuilding, setCurrentBuilding] = useState<typeHTHBuilding | null>(null);
    const [currentFace, setCurrentFace] = useState<typeHTHFace | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [refreshCounter, setRefreshCounter] = useState(0);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const closeBuildingModalHandler = () => navigate('/');

    useIdleTimeout(millisecondsFiveMinutes, closeBuildingModalHandler);

    useEffect(() => {
        if (!congregation || !territoryNumber || !block || !face || !streetNumber) {
            return;
        }
        houseToHouseServices.GetBuilding(congregation, territoryNumber, block, face, streetNumber).then(response => {
            setIsLoading(false);
            if (!response.success) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            const t = response.data?.hthTerritory;
            const f = t?.faces.find(x => x.block === block && x.face === face);
            const b = f?.buildings?.find(x => x.streetNumber === streetNumber);
            if (!t || !f || !b || !response.data?.config) {  // should not happen
                dispatch(setValuesAndOpenAlertModalReducer({
                    mode: 'alert',
                    title: 'Algo falló',
                    message: 'No se encontró el edificio; tal vez no haya internet',
                    animation: 2
                }));
                return;
            }
            setCurrentFace(f);
            setCurrentBuilding(b);
            setCongregationConfig(response.data.config);
        });
    }, [block, congregation, face, refreshCounter, streetNumber, territoryNumber]);

    useEffect(() => {
        const handler = (e: MessageEvent) => {
            const data = JSON.parse(e.data);
            if (data.congregation !== congregation) {
                return;
            }
            if (!!data.territoryNumber && data.territoryNumber !== territoryNumber) {
                return;
            }
            if (!!data.address && (data.address.block !== block || data.address.face !== face || data.address.streetNumber !== streetNumber)) {
                return;
            }
            setRefreshCounter(x => x + 1);
        };
        sse.addEventListener(sseEvents.hthChange, handler);
        return () => {
            sse.removeEventListener(sseEvents.hthChange, handler);
        };
    }, [block, congregation, face, streetNumber, territoryNumber]);

    if (isLoading) {
        return <Loading />;
    }

    if (!congregationConfig || !currentBuilding || !currentFace || !territoryNumber) {
        return <FailedToGetData />;
    }

    return (
        <HTHBuildingModal
            closeBuildingModalHandler={closeBuildingModalHandler}
            config={congregationConfig}
            currentBuilding={currentBuilding}
            currentFace={currentFace}
            territoryNumber={territoryNumber}
        />
    );
}
